<script lang="ts">
    import MediaImage from '$components/MediaImage/MediaImage.svelte';
    import Picture from '$components/Picture.svelte';
    import gao_placeholder_webp from '$assets/gao-placeholder.webp';
    import gao_placeholder_jpg from '$assets/gao-placeholder.jpg';

    export let mediaId: number | null | undefined;
    export let format: string;
    export let formatSet: Array<string | [string, string]> | null = null;

    let className = '';
    export { className as class };

    export let fallbackAlt: string | null = null;
    export let fallbackTitle: string | null = null;

    export let alt: string | null = null;
    export let title: string | null = null;
    export let placeholders: { jpg?: string; png?: string; webp?: string } | null = null;
</script>

{#if mediaId == null}
    <Picture
        class={className}
        alt={alt ?? fallbackAlt ?? 'placeholder gao'}
        title={title ?? fallbackTitle}
        webp={placeholders === null ? gao_placeholder_webp : placeholders.webp}
        jpg={placeholders === null ? gao_placeholder_jpg : placeholders.jpg}
        png={placeholders === null ? undefined : placeholders?.png}
    />
{:else}
    <MediaImage
        {mediaId}
        {format}
        {formatSet}
        class={className}
        {fallbackAlt}
        {fallbackTitle}
        {alt}
        {title}
    />
{/if}
